// extracted by mini-css-extract-plugin
module.exports = {"container":"SummaryItem-module__container--24X4E","text":"SummaryItem-module__text--1UtBi","label":"SummaryItem-module__label--2xIdl","value":"SummaryItem-module__value--2tIxp"};